import React from 'react';
import { ConfigProvider, Row, Col, Descriptions, Skeleton, Tabs, Select, message , Table, Space, Button } from 'antd';
import 'antd/dist/antd.css';
import "moment/locale/zh-cn";
import zhCN from 'antd/es/locale/zh_CN';
import './InteractiveView.scss'
import { APIService } from '../../../../services/commission/api';
import { returnIframeUrl } from "../../../../lib/http";
import Headline from "../../Headline/Headline.jsx"
import reactDialog from '../../../../lib/editableDialog';
import Popup from '../../Popup/Popup.jsx';
const { Option } = Select;
const { TabPane } = Tabs;

export default class InteractiveView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            projectNumber: "",
            projectID: "",
            private_message: [],
            particularsloading: false,
            extend_loading: false,
            Expand: "0",
            project: "招商平台",// 平台名称
            extend_information: [],
            openSeason: [], // 开放期列表 
            currentDate: '',
            download: "" ,

            LetterReport:[
                {
                    title: '文件唯一KEY值',
                    dataIndex: 'cms_file_id',
                    key: 'cms_file_id',
                    align:'center',
                    width: 100,
                },
                {
                    title: '文件名',
                    dataIndex: 'report_name',
                    key: 'report_name',
                    align:'center',
                    width: 150,
                },
                {
                    title: '文件类型',
                    dataIndex: 'report_type',
                    key: 'report_type ',
                    align:'center',
                    width: 20,
                },
                {
                    title: '文件大小(KB)',
                    dataIndex: 'file_leng',
                    key: 'fileSize',
                    align:'center',
                    width: 20,
                },
                {
                    title: '操作',
                    key: "opa",
                    fixed: 'right',
                    width: 60,
                    align:'center',
                    render: (text, record) => {
                        return (
                            <Space>
                                <Button 
                                    key={`${record['_id']}_view`} 
                                    type="primary" size="small"
                                    onClick={() => this.view(record)}
                                >预览</Button>
                            </Space>
                        )
                    }
                }
            ],
            contentReport:{},
            Report_order:['产品基本信息','发行方管理报告信息', '成立公告信息','临时公告信息','清算公告信息','到期公告信息'],
            letterOver_id:"",
            matter:"1", // 导航栏标的
            enumeration: {
                '信披报告': '2',
                '开放期计划': '3',
            }
        }
    }

    componentDidMount() {
        if (this.props.data.index){
            this.setState({
                matter:this.props.data.index, // 导航栏选择
                Expand: this.state.enumeration[this.props.data.present.f6], // 表格名称选择
            },() => {
                this.DetailedInformation(this.state.enumeration[this.props.data.present.f6])
            })
        }
        this.showDetail()
    }

    // 详情基本数据请求
    showDetail = () => {
        console.log(this.props.data.present, "props")
        this.setState({ 
            particularsloading: true, 
            projectNumber: this.props.data.present.f19, 
            projectID: this.props.data.present._id 
        })

        let params = {
            p_code: this.props.data.present.f19,
            // record_id: this.props.data.present._id,
            data_type: 0,
        }

        APIService.getDxjgProjInfo(params).then(res => {
            if (res.success) {
                if (res.orignal_data){
                    this.setState({ private_message: res.orignal_data, particularsloading: false })
                }else {
                    this.setState({ private_message: res.data, particularsloading: false })
                }
            } else {
                message.error(res.error);
            }
        }).catch(err => {
            console.log('重要提醒 Error', err);
        })

        this.setState((prev, props) => {
            return { visible: true }
        }, () => { })
    };

    // 基础信息详情
    DetailedInformation = (value) => {
        console.log("value",value)

        const { projectNumber, Expand, openSeason, projectID } = this.state
        this.setState({ extend_loading: true })
        if (value === "3") {
            let params = {
                p_code: projectNumber,
                record_id: projectID,
                data_type: -1,
            }
            APIService.getDxjgProjInfo(params).then(res => {
                if (res.success) {
                    if (res.data.length) {
                        this.setState({ openSeason: res.data, currentDate: res.data[0] }, () => {
                            let again = {
                                p_code: projectNumber,
                                data_type: Expand,
                                record_id: projectID,
                                open_year: res.data[0]
                            }

                            console.log(again, "again")

                            APIService.getDxjgProjInfo(again).then(res => {
                                if (res.success) {
                                    console.log(res, "res")
                                    this.setState({ extend_information: res.data, currentState: "3", download: res.file_id, extend_loading: false })
                                } else {
                                    message.error(res.error);
                                }
                            }).catch(err => {
                                console.log('重要提醒 Error', err);
                            })
                        })
                    } else {
                        this.setState({ Expand: "1", extend_loading: false })
                        message.warning("~ 暂无开放期 ~");
                    }
                } else {
                    message.error(res.error);
                }
            }).catch(err => {
                console.log('重要提醒 Error', err);
            })
        } else if (value === "1") {
            let again = {
                p_code: projectNumber,
                data_type: Expand,
            }

            APIService.getDxjgProjInfo(again).then(res => {
                if (res.success) {
                    console.log(res, "res")
                    this.setState({ extend_information: res.data, currentState: "2", extend_loading: false })
                } else {
                    message.error(res.error);
                }
            }).catch(err => {
                console.log('重要提醒 Error', err);
            })
        } else {
            let again = {
                row_id: projectID,
            }

            APIService.getXpReportInfo(again).then(res => {
                if (res.success) {
                    if(res.isEmpty) {
                        this.setState({ Expand: "1", extend_loading: false })
                        message.warning("~ 未查询到信披报告数据，请确认是否报送 ~");
                    }else {
                        this.setState({ contentReport: res.data, extend_loading: false })
                    }
                } else {
                    message.error(res.error);
                }
            }).catch(err => {
                console.log('重要提醒 Error', err);
            })

        }
    }

     // 详情中 切换开放日
    switchDate = () => {
        this.setState({ extend_loading: true })

        const { projectNumber, Expand, projectID , currentDate} = this.state

        let again = {
            p_code: projectNumber,
            data_type: Expand,
            record_id: projectID,
            open_year: currentDate
        }

        APIService.getDxjgProjInfo(again).then(res => {
            if (res.success) {
                console.log(res, "res")
                this.setState({ extend_information: res.data, currentState: "3", download: res.file_id, extend_loading: false })
            } else {
                message.error(res.error);
            }
        }).catch(err => {
            console.log('重要提醒 Error', err);
        })
    }



    // 详情信息tab切换
    callback = (key) => {
        console.log(key)
        const { projectNumber } = this.state
        this.setState({ extend_loading: true, Expand: this.state.enumeration[this.props.data.present.f6] || "1" })

        if (key == 2) {
            let params = {
                p_code: projectNumber,
                data_type: 1,
            }

            APIService.getDxjgProjInfo(params).then(res => {
                if (res.success) {
                    console.log(res, "res")
                    this.setState({ extend_information: res.data, currentState: "2", extend_loading: false })
                } else {
                    message.error(res.error);
                }
            }).catch(err => {
                console.log('重要提醒 Error', err);
            })
        }
    }

    FileDownload = () => {
        let { download } = this.state

        let url = returnIframeUrl('/download_attachment/', { file_id: download, download: 1 });
        let aElement = document.createElement('a'); //创建节点
        document.body.appendChild(aElement);
        aElement.style.display = 'none';
        aElement.href = url;
        aElement.target = '_blank';
        aElement.onclick = (res) => {
            console.log('click', res)
        };
        aElement.click();
        document.body.removeChild(aElement);
    }

    view = (record) => {
        let check = reactDialog;
        check.show({
            title: '预览',
            iszoom: true,
            el: Popup,
            data: record,
            className: "Popup"
        })
    }

    render() {
        const { private_message, particularsloading, extend_loading, currentState, extend_information, openSeason, currentDate , contentReport , matter } = this.state

        // 显示顺序---基础信息 
        const orderingList = {
            "产品基本信息": [
                '项目简称', '项目编号', '产品名称', '产品代码', '产品规模（万元）', '币种', '存续期是否开放', "认购募集开始日", "认购募集结束日",
                "产品成立日/计划起点", '产品到期日/计划终点', "开放期规则描述", '期限单位', '产品期限', '发行机构', '是否允许提前结束', '计息基数', '首次购买最低金额（元）',
                '购买步幅', '单笔购买金额下限（元）', '单笔购买金额上限（元）', '赎回步幅', '单笔赎回数量下限', '单笔赎回数量上限', '赎回后最少持有数量', '赎回/强制赎回天数',
                '合同是否控制', '控制金额（元）', '经办人','理财产品登记编码','认购资金扣款速度（日）','申购资金清算速度（日）','资管新规分类','产品类型','信托登记编号',
                '基金协会登记编号','其他类型编号','产品收益类型','业绩比较基准（区间低）（%）','业绩比较基准（区间高）（%）',
            ]
        }
        // 招商平台扩展信息
        const ExtensionSorting = {
            "产品基本信息": [
                '项目简称', '项目编号', '产品名称', '产品代码', '招行全称', "招行简称", '产品主代码', '基金结算货币市场', '线下购买是否有尾随', '网银展示方式', '是否需二次/多次缴款', '产品收益呈现方式', '预期收益率（年化%）',
                '可受理业务', '特殊情况提示'
            ],
            "产品费率信息": [
                '是否存在固定费率', '申购费（%）', '我行占分成比例（申购费）（%）', '认购费（%）', '我行占分成比例（认购费）（%）', '赎回费（不包含分段特殊情况）', '赎回费描述（兼容多段赎回费）','赎回费率多阶标志','多阶赎回费率详情', '我行占分成比例（赎回费）（%）',
                '销售服务费（%）', '固定管理费（%）', '其中我行应收固定管理费（%）', '托管费率（%）', '是否存在浮动费率', '提取净值门槛', '业绩报酬提取方法-固定时点提取', '业绩报酬提取方法-赎回触发或到期（即强制赎回）触发',
                '提取第1个产品净值（元）', '第1个提成比例（%）', '第1个银行提成比例（%）', '提取第2个产品净值（元）', '第2个提成比例（%）', '第2个银行提成比例（%）', '提取第3个产品净值（元）', '第3个提成比例（%）', '第3个银行提成比例（%）',
                '提取第4个产品净值（元）', '第4个提成比例（%）', '第4个银行提成比例（%）', '提取第5个产品净值（元）', '第5个提成比例（%）', '第5个银行提成比例（%）'
            ],
            "资金清算账户信息": [
                '托管账户户名', '托管账户账号', '托管账户开户网点', '托管账户资金交收方式', '托管账户大额支付号', '认购账户户名', '认购账户账号', '认购账户开户网点', '认购账户资金交收方式',
                '认购账户大额支付号', '申购账户户名', '申购账户账号','申购账户开户网点',  '申购账户资金交收方式', '申购账户大额支付号', '分红款账户户名', '分红款账户账号', '分红款账户开户网点',
                '分红款账户资金交收方式', '分红款账户大额支付号', '赎回款账户户名', '赎回款账户账号', '赎回款账户开户网点', '赎回款账户资金交收方式', '赎回款账户大额支付号', '认购退款账户户名',
                '认购退款账户账号', '认购退款账户开户网点', '认购退款账户资金交收方式','认购退款账户大额支付号'
            ],
            "联系人信息": [
                '系统运行联系人姓名', '系统运行联系人电话', '系统运行联系人邮箱', '资金划付联系人姓名', '资金划付联系人电话', '资金划付联系人邮箱', '收入核对联系人姓名', '收入核对联系人电话',
                '收入核对联系人邮箱', '项目经理姓名', '项目经理电话', '项目经理邮箱', '业务运行联系人姓名', '业务运行联系人电话', '业务运行联系人邮箱', '其他联系人姓名', '其他联系人电话',
                '其他联系人邮箱', '信息披露联系人姓名', '信息披露联系人电话', '信息披露联系人邮箱', '净值联系人姓名', '净值联系人电话', '净值联系人邮箱', '信披联系人姓名', '信披联系人电话',
                '信披联系人邮箱', '基金经理姓名', '基金经理电话', '基金经理邮箱'
            ],
            "净值监控信息": [
                '净值联系人电话', '净值联系人邮箱', '信披联系人姓名', '信披联系人电话', '信披联系人邮箱', '基金经理姓名', '基金经理电话', '基金经理邮箱节',
                '参考日历(规则一)', '节假日调整方式(规则一)', 'T日生成频率(规则一)', 'T日确定方式(规则一)', 'T日固定日期(规则一)', '获取截止日（T+N天）(规则一)',
                '参考日历(规则二)', '节假日调整方式(规则二)', 'T日生成频率(规则二)', 'T日确定方式(规则二)', 'T日固定日期(规则二)', '获取截止日（T+N天）(规则二)',
                '参考日历(规则三)', '节假日调整方式(规则三)', 'T日生成频率(规则三)', 'T日确定方式(规则三)', 'T日固定日期(规则三)', '获取截止日（T+N天）(规则三)',
            ],
        }
        // 开放期
        const OpeningPeriod = {
            "产品基本信息": [
                '项目简称', '项目编号', "产品代码", "产品名称", "开放期年份", "生成区间"
            ],
            "开放期计划信息": [
                "文件唯一key值", "文件名", "文件类型", "文件大小（KB）", "生成时间"
            ]
        }

        const sort_data = currentState == "2" ? ExtensionSorting : OpeningPeriod

        console.log(sort_data, "sort_data")

        return (
            <div>
                <ConfigProvider locale={zhCN}>
                    <div id='alternately'>
                        {/* <div className='produtpage-header'>
                            <Row>
                                <Col>
                                    <div style={{ lineHeight: "25px" }}>代销机构数据管理</div>
                                </Col>
                            </Row>
                        </div> */}
                        <div className="Presenter">
                            <Tabs key={matter} defaultActiveKey={matter} onChange={this.callback}>
                                <TabPane tab="基础信息" key="1">
                                    <Skeleton active loading={particularsloading}>
                                        {
                                            Object.keys(private_message).length && Object.keys(orderingList).map((panel, index) => {
                                                let titles = orderingList[panel]
                                                return <div key={index}>
                                                    <Headline title={panel} />
                                                    <Descriptions
                                                        bordered
                                                        column={2}
                                                    >
                                                        {
                                                            titles.map((title, index) => {
                                                                return private_message[panel][title] &&
                                                                    <Descriptions.Item span={1} key={index} label={private_message[panel][title].name}>
                                                                        {
                                                                            private_message[panel][title].dinput_type == "8" ?
                                                                                <Select
                                                                                    mode="multiple"
                                                                                    allowClear
                                                                                    style={{ width: '100%' }}
                                                                                    bordered={false}
                                                                                    disabled={true}
                                                                                    defaultValue={private_message[panel][title].data}
                                                                                >
                                                                                    {
                                                                                        private_message[panel][title].options.map(item => {
                                                                                            return <Option key={item.value}>{item.label}</Option>
                                                                                        })
                                                                                    }
                                                                                </Select>
                                                                                :
                                                                                (private_message[panel][title].dinput_type == "6" ?
                                                                                    <Select
                                                                                        bordered={false}
                                                                                        disabled={true}
                                                                                        filterOption={(input, option) =>
                                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                        }
                                                                                        getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                        defaultValue={private_message[panel][title].data}
                                                                                    >
                                                                                        {
                                                                                            private_message[panel][title].options.map(item => {
                                                                                                return <Select.Option value={item.value}>{item.label}</Select.Option>
                                                                                            })
                                                                                        }
                                                                                    </Select>
                                                                                    : <p style={{ marginLeft: "10px", width: "300px" }}>
                                                                                        {private_message[panel][title].data ? 
                                                                                        private_message[panel][title].data : (private_message[panel][title].data === 0 ? 0 : "")}
                                                                                    </p>
                                                                                )

                                                                        }

                                                                    </Descriptions.Item>
                                                            })
                                                        }
                                                    </Descriptions>
                                                </div>
                                            })
                                        }
                                    </Skeleton>
                                </TabPane>
                                <TabPane tab="扩展信息" key="2">
                                    <div className='customization'>
                                        <p className="triangle"></p>
                                        <p className="title_of">平台名称</p>
                                        <Select
                                            showSearch
                                            value={this.state.project}
                                            style={{ width: 160 }}
                                            placeholder="请选择平台名称"
                                            optionFilterProp="children"
                                            onChange={(value) => {
                                                this.setState({ project: value })
                                            }}
                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value="招商平台">招商平台</Option>
                                        </Select>

                                        <p className="title_of interval">表格名称</p>
                                        <Select
                                            showSearch
                                            style={{ width: 140 }}
                                            value={this.state.Expand}
                                            placeholder="请选择扩展名称"
                                            optionFilterProp="children"
                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                            onChange={(value) => {
                                                console.log(value, "value");
                                                this.setState({ Expand: value }, () => {
                                                    this.DetailedInformation(value)
                                                })
                                            }}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Select.Option value="1">产品扩展信息</Select.Option>
                                            <Select.Option value="3">开放期计划信息</Select.Option>
                                            <Select.Option value="2">信披报告信息</Select.Option>
                                        </Select>
                                        {
                                            this.state.Expand === "3" && openSeason.length ?
                                                <div style={{ display: 'flex' }}>
                                                    <p className="title_of interval">开放期</p>
                                                    <Select
                                                        showSearch
                                                        style={{ width: 160 }}
                                                        value={currentDate}
                                                        placeholder="请选择开放期"
                                                        optionFilterProp="children"
                                                        onChange={(value) => {
                                                            this.setState({ currentDate: value }, () => {
                                                                this.switchDate()
                                                            })
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {
                                                            openSeason.map((item, index) => {
                                                                return <Option value={item}>{item}</Option>
                                                            })
                                                        }
                                                    </Select>
                                                </div> : ""
                                        }
                                    </div>
                                    <Skeleton active loading={extend_loading}>
                                        {
                                           (Object.keys(extend_information).length &&  this.state.Expand !== "2") ? Object.keys(sort_data).map((panel, index) => {
                                                let titles = sort_data[panel]
                                                return <div key={index}>
                                                    <Headline title={panel} />
                                                    <Descriptions
                                                        bordered
                                                        column={2}
                                                    >
                                                        {
                                                            titles.map((title, index) => {
                                                                return extend_information[panel][title] &&
                                                                    <Descriptions.Item
                                                                        span={
                                                                            extend_information[panel][title].name == "托管账户大额支付号" || extend_information[panel][title].name == "认购账户大额支付号" || extend_information[panel][title].name == "申购账户大额支付号" ||
                                                                                extend_information[panel][title].name == "分红款账户大额支付号" || extend_information[panel][title].name == "认购退款账户大额支付号" || extend_information[panel][title].name == "赎回款账户大额支付号" ||
                                                                                extend_information[panel][title].name == "系统运行联系人邮箱" || extend_information[panel][title].name == "资金划付联系人邮箱" || extend_information[panel][title].name == "收入核对联系人邮箱" ||
                                                                                extend_information[panel][title].name == "项目经理邮箱" || extend_information[panel][title].name == "业务运行联系人邮箱" || extend_information[panel][title].name == "其他联系人邮箱" ||
                                                                                extend_information[panel][title].name == "信息披露联系人邮箱" || extend_information[panel][title].name == "净值联系人邮箱" || extend_information[panel][title].name == "信披联系人邮箱" ||
                                                                                extend_information[panel][title].name == "基金经理邮箱" ? 2 : 1
                                                                        }
                                                                        key={index}
                                                                        label={extend_information[panel][title].name}
                                                                    >
                                                                        {
                                                                            extend_information[panel][title].dinput_type == "8" ?
                                                                                <Select
                                                                                    mode="multiple"
                                                                                    allowClear
                                                                                    style={{ width: '100%' }}
                                                                                    bordered={false}
                                                                                    disabled={true}
                                                                                    defaultValue={extend_information[panel][title].data}
                                                                                >
                                                                                    {
                                                                                        extend_information[panel][title].options.map(item => {
                                                                                            return <Option key={item.value}>{item.label}</Option>
                                                                                        })
                                                                                    }
                                                                                </Select>
                                                                                :
                                                                                (extend_information[panel][title].dinput_type == "6" ?
                                                                                    <Select
                                                                                        bordered={false}
                                                                                        disabled={true}
                                                                                        filterOption={(input, option) =>
                                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                        }
                                                                                        getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                        defaultValue={extend_information[panel][title].data}
                                                                                    >
                                                                                        {
                                                                                            extend_information[panel][title].options.map(item => {
                                                                                                return <Select.Option value={item.value}>{item.label}</Select.Option>
                                                                                            })
                                                                                        }
                                                                                    </Select>
                                                                                    : extend_information[panel][title].name == "文件名" ?
                                                                                        <p
                                                                                            className="file_download"
                                                                                            onClick={this.FileDownload}
                                                                                        >
                                                                                            {extend_information[panel][title].data ? extend_information[panel][title].data : ""}
                                                                                        </p> :
                                                                                        // <p style={{ marginLeft: "10px", width: "300px" }}>{(extend_information[panel][title].data || extend_information[panel][title].data === 0 )? extend_information[panel][title].data : ""}</p>
                                                                                        <div style={{padding:"0 11px"}}>
                                                                                            {
                                                                                                (extend_information[panel][title].data).constructor == Array ?
                                                                                                <div>
                                                                                                    {
                                                                                                        extend_information[panel][title].data.map((e,i)=>{
                                                                                                            return <p  key={i} style={{display: "flex", justifyContent: "space-around"}}>
                                                                                                                <span>范围最小值：{e.min}</span>
                                                                                                                <span>范围最大值：{e.max}</span>
                                                                                                                <span>赎回费率（%）：{e.redFee}</span>
                                                                                                                <span>范围单位：{e.unit}</span>
                                                                                                            </p>
                                                                                                        })
                                                                                                    }
                                                                                                </div>
                                                                                                :
                                                                                                <span>{extend_information[panel][title].data}</span>
                                                                                            }
                                                                                        </div>
                                                                                )

                                                                        }

                                                                    </Descriptions.Item>
                                                            })
                                                        }
                                                    </Descriptions>
                                                </div> 
                                            }) :  <div>
                                                {
                                                    Object.keys(contentReport).length && this.state.Report_order.map((item,index) => {
                                                        return  item == "产品基本信息" ?  <div key={index}>
                                                            <Headline title={item} />
                                                            <Descriptions column={2}  bordered>
                                                                {
                                                                    Object.keys(contentReport[item]).map((i,index) => {
                                                                        return  <Descriptions.Item label={i} key={index}>{contentReport["产品基本信息"][i].data ? contentReport["产品基本信息"][i].data : ""}</Descriptions.Item>
                                                                    })
                                                                }
                                                            </Descriptions>
                                                        </div> : 
                                                        <div key={index}>
                                                            <Headline title={item} />
                                                            <Table 
                                                                columns={this.state.LetterReport} 
                                                                dataSource={contentReport[item].data}
                                                                pagination={false}
                                                                bordered 
                                                            />
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        }
                                    </Skeleton>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </ConfigProvider>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// app/components/customPage/commission/InteractiveView/InteractiveView.jsx